// services/everpro/everpro-location/subDistrict.ts — pilih sub_district_id yang SESUAI teks
// Sebelumnya: selalu [0] → kodepos multi-kelurahan (mis. 36124) bisa jatuh ke
// kelurahan tetangga (Simpang Empat Sipin) padahal customer di Kenali Asam.
// Sekarang: exact match nama desa (fallback kecamatan), baru [0].
const clean = (v?: string | null): string =>
  String(v || '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();

export interface SubDistrictHint {
  village?: string | null;
  district?: string | null;
}

export function pickSubDistrict(list: any, hint: SubDistrictHint): any | null {
  const arr = Array.isArray(list) ? list : list ? [list] : [];
  if (!arr.length) return null;
  if (arr.length === 1) return arr[0];
  const v = clean(hint.village);
  if (v) {
    const exact = arr.find((d) => clean(d?.sub_district_name) === v);
    if (exact) return exact;
    const contains = arr.find((d) => {
      const n = clean(d?.sub_district_name);
      return n && (n.includes(v) || v.includes(n));
    });
    if (contains) return contains;
  }
  const k = clean(hint.district);
  if (k) {
    const byDist = arr.find((d) => clean(d?.district_name) === k);
    if (byDist) return byDist;
  }
  return arr[0];
}
